// src/pages/Admin/TotalDeposit.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";

export default function TotalDeposit() {
  const [funds, setFunds] = useState([]);
  const [filteredFunds, setFilteredFunds] = useState([]);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  useEffect(() => {
    fetchApprovedFunds();
  }, []);

  const fetchApprovedFunds = async () => {
  try {
    const res = await axios.get("https://api.earnmoney0.top/admin/approved-funds");
    if (res.data.success) {
      setFunds(res.data.funds || []);
      setFilteredFunds(res.data.funds || []);
    }
  } catch (err) {
    console.error("❌ Fetch Approved Funds Error:", err);
  }
};

  useEffect(() => {
    let data = [...funds];
    if (search.trim()) {
  data = data.filter(
    f =>
      f.userId?.username?.toLowerCase().includes(search.toLowerCase()) ||
      f.userId?.phone?.toLowerCase().includes(search.toLowerCase()) ||
      f.number?.toLowerCase().includes(search.toLowerCase())
  );
}
    if (startDate) data = data.filter(f => new Date(f.createdAt) >= new Date(startDate));
    if (endDate) data = data.filter(f => new Date(f.createdAt) <= new Date(endDate));
    setFilteredFunds(data);
  }, [search, startDate, endDate, funds]);

  const exportToCSV = () => {
    if (filteredFunds.length === 0) {
      alert("⚠️ No data to export!");
      return;
    }
    const headers = ["Username,Email,Txn ID,Method,Amount (৳),Status,Date\n"];
    const rows = filteredFunds.map(f => {
      const date = new Date(f.createdAt).toLocaleString("en-GB");
      return `${f.userId?.username || "Unknown"},${f.userId?.email || "N/A"},${f.transactionId},${f.method},${f.amount},${f.status},${date}`;
    });
    const blob = new Blob([headers + rows.join("\n")], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `Approved_Funds_${new Date().toISOString().slice(0, 10)}.csv`;
    link.click();
  };

  return (
    <div className="total-deposit-page">
      {/* Inline CSS */}
      <style>{`
        .total-deposit-page {
          min-height: 100vh;
          background-color: #0b0f1a;
          color: white;
          padding: 24px;
          display: flex;
          flex-direction: column;
          font-family: sans-serif;
        }
        .header-export {
          display: flex;
          flex-direction: column;
          gap: 12px;
          margin-bottom: 24px;
        }
        .header-export h2 {
          color: #22c55e;
          font-size: 28px;
          font-weight: bold;
        }
        .header-export button {
          background: #22c55e;
          color: black;
          font-weight: 600;
          border: none;
          border-radius: 8px;
          padding: 8px 18px;
          cursor: pointer;
          transition: 0.3s;
        }
        .header-export button:hover {
          background: #16a34a;
        }
        .filters {
          display: flex;
          flex-direction: column;
          gap: 12px;
          margin-bottom: 24px;
        }
        .filters input[type="text"] {
          background: #1b2138;
          border: 1px solid #444;
          border-radius: 6px;
          color: white;
          padding: 8px 12px;
          width: 100%;
        }
        .date-filters {
          display: flex;
          gap: 8px;
          flex-wrap: wrap;
          align-items: center;
        }
        .date-filters label {
          color: #aaa;
          font-size: 14px;
        }
        .date-filters input[type="date"] {
          background: #1b2138;
          border: 1px solid #444;
          border-radius: 6px;
          color: white;
          padding: 6px 10px;
        }
        .table-wrapper {
          flex: 1;
          overflow-x: auto;
          border: 1px solid #444;
          border-radius: 8px;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          min-width: 800px;
        }
        thead {
          background-color: #111827;
          color: #22c55e;
          text-transform: uppercase;
        }
        th, td {
          padding: 12px;
          text-align: left;
        }
        tbody tr {
          border-bottom: 1px solid #444;
          transition: background 0.3s;
        }
        tbody tr:hover {
          background-color: #1f2937;
        }
        .txn-id {
          color: #00eaff;
          font-weight: 600;
        }
        .amount {
          color: #22c55e;
          font-weight: 600;
        }
        .status {
          background-color: #22c55e;
          color: black;
          font-weight: 600;
          padding: 4px 8px;
          border-radius: 9999px;
          font-size: 12px;
        }
        .date {
          color: #aaa;
        }
        .no-data {
          text-align: center;
          font-style: italic;
          color: #888;
        }
        @media (min-width: 768px) {
          .header-export {
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
          }
          .filters {
            flex-direction: row;
            align-items: center;
          }
          .filters input[type="text"] {
            width: 30%;
          }
        }
      `}</style>

      <div className="header-export">
        <h2>💹 Total Deposit — Approved Funds</h2>
        <button onClick={exportToCSV}>⬇️ Export CSV</button>
      </div>

      <div className="filters">
        <input
          type="text"
          placeholder="🔍 Search username, email, or Txn ID..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        <div className="date-filters">
          <label>From:</label>
          <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} />
          <label>To:</label>
          <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} />
        </div>
      </div>

      <div className="table-wrapper">
        <table>
          <thead>
  <tr>
    <th>#</th>
    <th>Username</th>
    <th>Phone</th>
    <th>Method</th>
    <th>Number</th>
    <th>Amount (৳)</th>
    <th>Status</th>
    <th>Date</th>
  </tr>
</thead>
          <tbody>
  {filteredFunds.length === 0 ? (
    <tr>
      <td colSpan="8" className="no-data">No approved funds found</td>
    </tr>
  ) : (
    filteredFunds.map((f, index) => (
      <tr key={f._id}>
        <td>{index + 1}</td> {/* Serial */}
        <td>{f.userId?.name || "Unknown"}</td>
        <td>{f.userId?.phone || "N/A"}</td> {/* Phone */}
        <td>{f.method}</td>
        <td>{f.number || "N/A"}</td> {/* Number */}
        <td className="amount">৳{f.amount}</td>
        <td><span className="status">{f.status}</span></td>
        <td className="date">{new Date(f.createdAt).toLocaleString("en-GB")}</td>
      </tr>
    ))
  )}
</tbody>
        </table>
      </div>
    </div>
  );
}